(ns net.kestec.mhda-pilgrimage.admin.dashboard
  (:require
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Card" :default Card]
    ["@mui/material/CardHeader" :default CardHeader]
    ["@mui/material/CardContent" :default CardContent]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias applications-events]

    ))



(defn overview []
  (let [stat @(rf/subscribe [::db/get ::applications-events/admin-statistic :overview])]
    [:<>
     [:> Grid {:container   true :direction "row" :spacing 2 :justify "space-between" :style {:width "100%"}
               :align-items "top"}

      [:> Grid {:item true :size {:xs 12}}
       [:> Card {:style {:width "100%"}}
        ;[:pre (pr-str stat)]
        [:> CardHeader {:style {:padding "7px" :font-size "9px"} :subheader (str "Statistik")}]
        [:> CardContent {:style {:padding "7px" :width "100%"}}
         [:> Grid {:container   true :direction "row" :spacing 2 :justify "space-between" :style {:width "100%"}
                   :align-items "top"}
          [:> Grid {:item true :size {:xs 12 :lg 6}}
           [:table
            [:tbody

             [:tr [:th ""]
              [:th {:style {:min-width "70px"}} "Summe"] [:th {:style {:min-width "70px"}} "B"] [:th {:style {:min-width "70px"}} "OÖ"]
              [:th {:style {:min-width "70px"}} "SA"] [:th {:style {:min-width "70px"}} "ST"] [:th {:style {:min-width "70px"}} "W"]
              [:th {:style {:min-width "70px"}} "T"] [:th {:style {:min-width "70px"}} "Bund"] [:th {:style {:min-width "70px"}} "ohne"]]


             [:tr [:th {:style {:text-align "left" :padding-right "15px"}} [:br]]]

             (into [:tr [:th {:style {:text-align "left" :padding-right "15px"}} "Anmeldungen in Arbeit"]]
                   (for [div [:all :B :OO :Sb :St :W :T :Bu (keyword "")]] [:td {:style {:text-align "center"}} (get-in stat [div :cnt])]))

             [:tr [:th {:style {:text-align "left" :padding-right "15px"}} [:br]]]

             (into [:tr [:th {:style {:text-align "left" :padding-right "15px"}} "Abgeschlossene Anmeldungen"]]
                   (for [div [:all :B :OO :Sb :St :W :T :Bu (keyword "")]] [:td {:style {:text-align "center"}} (get-in stat [div :cnt_done])]))

             [:tr [:th {:style {:text-align "left" :padding-right "15px"}} [:br]]]
             (into [:tr [:th {:style {:text-align "left" :padding-right "15px"}} "Geprüfte Anmeldungen"]]
                   (for [div [:all :B :OO :Sb :St :W :T :Bu (keyword "")]] [:td {:style {:text-align "center"}} (get-in stat [div :cnt_checked])]))

             (into [:tr [:th {:style {:text-align "left" :padding-right "15px"}} "Bezahlte Anmeldungen"]]
                   (for [div [:all :B :OO :Sb :St :W :T :Bu (keyword "")]] [:td {:style {:text-align "center"}} (get-in stat [div :cnt_paid])]))
             [:tr [:th {:style {:text-align "left" :padding-right "15px"}} [:br]]]

             [:tr [:th {:style {:text-align "left" :padding-right "15px"}} ""]]

             ]]]]]
        [:br]]]
      ]]))

(defn contingent-view []
  (let [contingents @(rf/subscribe [::db/get ::applications-events/admin-statistic :contingent])
        all (:all contingents)]
    [:<>
     [:> Grid {:container   true :direction "row" :spacing 2 :justify "space-between" :style {:width "100%"}
               :align-items "top"}

      [:> Grid {:item true :size {:xs 12}}
       [:> Card {:style {:width "100%"}}
        ;[:pre (pr-str stat)]
        [:> CardHeader {:style {:padding "7px" :font-size "9px"} :subheader (str "Kontingente")}]
        [:> CardContent {:style {:padding "7px" :width "100%"}}
         [:> Grid {:container   true :direction "row" :spacing 2 :justify "space-between" :style {:width "100%"}
                   :align-items "top"}
          [:> Grid {:item true :size {:xs 12 :lg 6}}
           [:table {:border "1"}
            (into
              (into [:tbody

                   [:tr
                    [:th "Bereich"]
                    [:th {:style {:min-width "70px" :padding "4px" :color "darkblue"}} "PI Knt"]
                    [:th {:style {:min-width "70px" :padding "4px"}} "PI Fix"]
                    [:th {:style {:min-width "70px" :padding "4px"}} "PI Wrt"]
                    [:th {:style {:min-width "20px" :padding "4px"}} " "]
                    [:th {:style {:min-width "70px" :padding "4px" :color "darkblue"}} "PA Knt"]
                    [:th {:style {:min-width "70px" :padding "4px"}} "PA Fix"]
                    [:th {:style {:min-width "70px" :padding "4px"}} "PA Wrt"]
                    [:th {:style {:min-width "20px" :padding "4px"}} " "]
                    [:th {:style {:min-width "70px" :padding "4px" :color "darkblue"}} "PE Knt"]
                    [:th {:style {:min-width "70px" :padding "4px"}} "PE Fix"]
                    [:th {:style {:min-width "70px" :padding "4px"}} "PE Wrt"]


                    ]

                   ]
                  (for [[k contingent] (remove (fn [[k c]] (= k :all)) (sort-by first contingents))]
                    [:tr
                     [:th {:style {:text-align "center" :padding-right "15px"}} (:division contingent)]

                     [:td {:style {:text-align "center" :padding-right "15px" :color "darkblue"}} (:PI contingent)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PI_cnt_fix contingent)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PI_cnt_waiting contingent) " (" (:PI_cnt_complete contingent) ")"]
                     [:td]
                     [:td {:style {:text-align "center" :padding-right "15px" :color "darkblue"}} (:PA contingent)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PA_cnt_fix contingent)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PA_cnt_waiting contingent) " (" (:PA_cnt_complete contingent) ")"]
                     [:td]
                     [:td {:style {:text-align "center" :padding-right "15px" :color "darkblue"}} (:PE contingent)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PE_cnt_fix contingent)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PE_cnt_waiting contingent) " (" (:PE_cnt_complete contingent) ")"]
                     ]))
                    [[:tr [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "] [:td " "]]
                    [:tr {:style {:backgroundColor "lightblue"}}
                     [:th {:style {:text-align "center" :padding-right "15px"}} (:division all)]

                     [:td {:style {:text-align "center" :padding-right "15px" :color "darkblue"}} (:PI all)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PI_cnt_fix all)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PI_cnt_waiting all) " (" (:PI_cnt_complete all) ")"]
                     [:td]
                     [:td {:style {:text-align "center" :padding-right "15px" :color "darkblue"}} (:PA all)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PA_cnt_fix all)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PA_cnt_waiting all) " (" (:PA_cnt_complete all) ")"]
                     [:td]
                     [:td {:style {:text-align "center" :padding-right "15px" :color "darkblue"}} (:PE all)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PE_cnt_fix all)]
                     [:td {:style {:text-align "center" :padding-right "15px"}} (:PE_cnt_waiting all) " (" (:PE_cnt_complete all) ")"]
                   ]])
                  ]]]]
        [:br]
        ;[:pre (pr-str contingents)]
        ]]
      ]]))

(defn main []
  [base-page
   [:> Paper {:sx {:padding "7px"}}
    [:br]
    [:> Typography {:variant "h2"} "Admin Dashboard"]


    [overview]
    [contingent-view]

    ]])


